module.exports = __webpack_public_path__ + "img/lake-river.841015c1.jpg";